<app-header></app-header>
<app-navigation></app-navigation>
<div class='column'>
  <ng-content selector='.content'></ng-content>
</div>
<app-footer></app-footer>